"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FooterContents = exports.Footer = exports.HeaderContainer = exports.ContentContainer = void 0;

var tslib_1 = require("tslib");

var ui_box_1 = require("@hopin-team/ui-box");

var ui_flex_1 = require("@hopin-team/ui-flex");

var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");

var ui_helper_props_to_styles_1 = require("@hopin-team/ui-helper-props-to-styles");

var styled_components_1 = tslib_1.__importDefault(require("styled-components"));

var MaxHeights;

(function (MaxHeights) {
  MaxHeights["small"] = "max-height: 70vh;";
  MaxHeights["medium"] = "max-height: 80vh;";
  MaxHeights["large"] = "max-height: 90vh;";
})(MaxHeights || (MaxHeights = {}));

var DialogMaxHeights;

(function (DialogMaxHeights) {
  DialogMaxHeights["small"] = "max-height: 90vh;";
  DialogMaxHeights["medium"] = "max-height: 90vh;";
  DialogMaxHeights["large"] = "max-height: 90vh;";
})(DialogMaxHeights || (DialogMaxHeights = {}));

exports.ContentContainer = (0, styled_components_1.default)(ui_flex_1.Flex).attrs({
  flexDirection: 'column'
})(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  ", "\n  ", "\n"], ["\n  ", "\n  ", "\n"])), function (props) {
  return !props.isDialog && (0, ui_helper_props_to_styles_1.mapStyles)(props, 'size', MaxHeights);
}, function (props) {
  return props.isDialog && (0, ui_helper_props_to_styles_1.mapStyles)(props, 'size', DialogMaxHeights);
});
exports.HeaderContainer = (0, styled_components_1.default)(ui_box_1.Box)(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  border-radius: 1rem 1rem 0 0;\n  border-bottom: ", ";\n  border-bottom-color: ", ";\n  color: ", ";\n"], ["\n  border-radius: 1rem 1rem 0 0;\n  border-bottom: ", ";\n  border-bottom-color: ", ";\n  color: ", ";\n"])), function (_a) {
  var withSeparator = _a.withSeparator;
  return withSeparator ? '0.0625rem solid' : 'none';
}, function (_a) {
  var isInverse = _a.isInverse,
      theme = _a.theme;
  return isInverse ? (0, ui_helper_deep_branding_1.getFromTheme)("COLOR.GREY[\"700\"]", theme) : (0, ui_helper_deep_branding_1.getFromTheme)("COLOR.GREY[\"200\"]", theme);
}, function (_a) {
  var isInverse = _a.isInverse,
      theme = _a.theme;
  return isInverse && (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.GREY.WHITE', theme);
});
exports.Footer = (0, styled_components_1.default)(ui_flex_1.Flex)(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n  border-top: ", ";\n  border-top-color: ", ";\n  justify-content: ", ";\n"], ["\n  border-top: ", ";\n  border-top-color: ", ";\n  justify-content: ", ";\n"])), function (_a) {
  var withSeparator = _a.withSeparator;
  return withSeparator ? '0.0625rem solid' : 'none';
}, function (_a) {
  var isInverse = _a.isInverse,
      theme = _a.theme;
  return isInverse ? (0, ui_helper_deep_branding_1.getFromTheme)("COLOR.GREY[\"700\"]", theme) : (0, ui_helper_deep_branding_1.getFromTheme)("COLOR.GREY[\"200\"]", theme);
}, function (_a) {
  var isDialog = _a.isDialog;
  return isDialog ? 'stretch' : 'flex-end';
});
exports.FooterContents = (0, styled_components_1.default)(ui_flex_1.Flex)(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["\n  gap: 1rem;\n  flex: ", ";\n  border-radius: 0 0 1rem 1rem;\n"], ["\n  gap: 1rem;\n  flex: ", ";\n  border-radius: 0 0 1rem 1rem;\n"])), function (_a) {
  var isDialog = _a.isDialog;
  return isDialog ? '1' : '0';
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;